  <ags-demandes-encadrement-list
    [header-background]="'muted'"
    [header-color]="'primary'"
    (demandesOutput)="getDemandes($event)"
    (goToDetailOutput)="changeRoute($event)"
  ></ags-demandes-encadrement-list>